import { ShieldCheck, Mail, GraduationCap, FileText } from 'lucide-react'

// SaaS products offered on subscription. Each powers a card on /products and a
// full page at /products/:slug. Prices are placeholders — edit freely.
export const products = [
  {
    slug: 'soc',
    name: 'Spectranox SOC',
    icon: ShieldCheck,
    status: 'Available',
    tagline: 'Security Operations Center, as a service.',
    summary:
      'Real-time threat monitoring, log correlation and incident response — without building your own SOC.',
    description:
      'Spectranox SOC continuously monitors your infrastructure, correlates events across your stack, and alerts your team the moment something looks wrong. Get enterprise-grade security operations on a predictable monthly subscription, fully hosted and managed by us.',
    features: [
      'Real-time threat detection & alerting',
      'Centralised log collection & correlation',
      'Automated incident response playbooks',
      'Compliance dashboards (ISO, SOC 2, GDPR)',
      'Optional 24/7 managed monitoring',
    ],
    pricing: [
      {
        name: 'Starter',
        price: 99,
        period: 'mo',
        description: 'For small teams getting started with monitoring.',
        features: ['Up to 5 sources', 'Core detection rules', 'Email alerts', 'Community support'],
      },
      {
        name: 'Growth',
        price: 299,
        period: 'mo',
        popular: true,
        description: 'For growing companies that need real coverage.',
        features: ['Up to 25 sources', 'Custom correlation rules', 'Slack & email alerts', 'Compliance reports', 'Priority support'],
      },
      {
        name: 'Enterprise',
        price: null,
        period: '',
        description: 'For organisations needing managed 24/7 SOC.',
        features: ['Unlimited sources', '24/7 managed SOC', 'Dedicated analyst', 'Custom SLAs', 'On-prem option'],
      },
    ],
  },
  {
    slug: 'mail',
    name: 'Spectranox Mail',
    icon: Mail,
    status: 'Available',
    tagline: 'Secure business mailbox & collaboration.',
    summary:
      'Private, encrypted business email with your own domain, calendars and shared mailboxes.',
    description:
      'Spectranox Mail gives your business professional, encrypted email on your own domain — with calendars, contacts, shared mailboxes and spam protection. Fully hosted, privacy-first, and billed per user per month.',
    features: [
      'Custom domain email (you@yourcompany.com)',
      'End-to-end encryption & spam protection',
      'Calendars, contacts & shared mailboxes',
      'Webmail + mobile & desktop clients',
      'Generous storage with easy migration',
    ],
    pricing: [
      {
        name: 'Basic',
        price: 3,
        period: 'user/mo',
        description: 'Professional email for individuals & small teams.',
        features: ['10 GB per mailbox', 'Custom domain', 'Spam & virus protection', 'Webmail access'],
      },
      {
        name: 'Business',
        price: 6,
        period: 'user/mo',
        popular: true,
        description: 'More storage and collaboration for teams.',
        features: ['50 GB per mailbox', 'Shared mailboxes & calendars', 'Priority delivery', 'Email support'],
      },
      {
        name: 'Enterprise',
        price: null,
        period: '',
        description: 'Advanced controls & compliance for larger orgs.',
        features: ['Unlimited storage', 'Advanced security policies', 'Audit & compliance', 'Dedicated support'],
      },
    ],
  },
  {
    slug: 'learn',
    name: 'Spectranox Learn',
    icon: GraduationCap,
    status: 'Beta',
    tagline: 'A modern Learning Management System.',
    summary:
      'Create, sell and deliver courses with quizzes, certificates and progress tracking.',
    description:
      'Spectranox Learn is a complete LMS for academies, businesses and creators. Build courses, run assessments, issue certificates and track learner progress — all on a branded, hosted platform you can launch in days.',
    features: [
      'Course builder with video & quizzes',
      'Certificates & progress tracking',
      'Student & instructor portals',
      'Payments & subscription courses',
      'Branding on your own domain',
    ],
    pricing: [
      {
        name: 'Educator',
        price: 19,
        period: 'mo',
        description: 'For individual instructors and small academies.',
        features: ['Up to 100 students', 'Unlimited courses', 'Quizzes & certificates', 'Email support'],
      },
      {
        name: 'Academy',
        price: 49,
        period: 'mo',
        popular: true,
        description: 'For schools and growing training businesses.',
        features: ['Up to 1,000 students', 'Custom branding', 'Payments integration', 'Analytics', 'Priority support'],
      },
      {
        name: 'Institution',
        price: null,
        period: '',
        description: 'For universities and large organisations.',
        features: ['Unlimited students', 'SSO & integrations', 'Dedicated hosting', 'Custom SLAs'],
      },
    ],
  },
  {
    slug: 'cms',
    name: 'Spectranox CMS',
    icon: FileText,
    status: 'Coming soon',
    tagline: 'Headless content management, simplified.',
    summary:
      'Manage content once and publish anywhere — websites, apps and digital displays.',
    description:
      'Spectranox CMS is a flexible, headless content platform. Model your content, edit it in a clean interface, and deliver it through a fast API to any front end — websites, mobile apps or signage. Hosted, scalable and developer-friendly.',
    features: [
      'Flexible content modelling',
      'Clean editor for non-technical teams',
      'Fast content delivery API',
      'Roles, workflows & versioning',
      'Media library & CDN delivery',
    ],
    pricing: [
      {
        name: 'Starter',
        price: 15,
        period: 'mo',
        description: 'For blogs, portfolios and small sites.',
        features: ['2 projects', '3 editors', 'API access', 'Community support'],
      },
      {
        name: 'Team',
        price: 39,
        period: 'mo',
        popular: true,
        description: 'For teams managing multiple properties.',
        features: ['10 projects', 'Unlimited editors', 'Workflows & roles', 'CDN delivery', 'Priority support'],
      },
      {
        name: 'Scale',
        price: null,
        period: '',
        description: 'For high-traffic, multi-brand setups.',
        features: ['Unlimited projects', 'Dedicated infrastructure', 'SSO & audit logs', 'Custom SLAs'],
      },
    ],
  },
]

export const getProduct = (slug) => products.find((p) => p.slug === slug)
